import { WidgetDashboardFilterApplication } from '@cxstudio/dashboards/dashboard-filters/WidgetDashboardFilterApplication';

export abstract class WidgetDashboardFilterProcessor {

	abstract process: (filterApplication: WidgetDashboardFilterApplication) => ng.IPromise<void>;

}
